/**
 * MessageTemplateEditForm コンポーネント
 *
 * メッセージテンプレート編集フォームを表示するためのコンポーネント。
 * 初期値を設定して MessageTemplateForm をレンダリングします。
 *
 * @file メッセージテンプレート編集ページのフォーム部分
 * @date 2025/06/26
 */
import React from 'react';
import { MessageTemplateForm } from 'src/components/model/messageTemplate/form';
import { MessageTemplateFormType } from 'src/models/messageTemplate';

type Props = {
  formValue: MessageTemplateFormType;
};

/**
 * メッセージテンプレート編集フォーム
 *
 * @param formValue 初期値を設定するためのプロパティ
 */
export const MessageTemplateEditForm: React.FC<Props> = ({ formValue }) => {
  return <MessageTemplateForm init={formValue} />;
};
